import { NumberInput, SimpleSelect, TextInput } from 'corso-admin-ui';
import { Controller } from 'react-hook-form';

import { useAutomationFormContext } from '~/features/settings/automations/hooks/useAutomationForm';
import { useDiscountDefinitions } from '~/features/settings/hooks/useDiscountDefinitions';

export default function EventRegistrationDiscount() {
  const { control } = useAutomationFormContext();
  const { data: discountDefinitions } = useDiscountDefinitions();

  const discountDefinitionOptions = discountDefinitions.map((definition) => ({
    label: definition.title,
    value: `${definition.id}`,
  }));

  return (
    <>
      <Controller
        control={control}
        name="event.params.storeDiscountDefinitionId"
        render={({ field: { onChange, value }, fieldState }) => (
          <SimpleSelect
            label="Discount"
            details="The discount to issue when a Registration is created."
            placeholder="Select a discount"
            options={discountDefinitionOptions}
            value={value ? `${value}` : ''}
            onChange={(next) => onChange(Number(next))}
            error={fieldState.error?.message}
          />
        )}
      />

      <Controller
        control={control}
        name="event.params.discountValidityDays"
        render={({ field, fieldState }) => (
          <NumberInput
            id="discount-validity-days"
            label="Expiration Days"
            details="The number of days the discount code will be valid for after being issued (leave blank for no expiration)."
            value={field.value}
            onChange={(e) => field.onChange(e.target.valueAsNumber)}
            error={fieldState.error?.message}
          />
        )}
      />

      <Controller
        control={control}
        name="event.params.discountCustomerMessage"
        render={({ field, fieldState }) => (
          <TextInput
            id="discount-customer-message"
            label="Message"
            details="Shown to the customer alongside the discount code after it's issued."
            {...field}
            value={field.value ?? ''}
            error={fieldState.error?.message}
          />
        )}
      />

      <Controller
        control={control}
        name="event.params.discountRedirectUrl"
        render={({ field, fieldState }) => (
          <TextInput
            id="discount-redirect-url"
            label="Redirect URL"
            details="The URL to redirect the customer to after the discount is applied."
            {...field}
            value={field.value}
            error={fieldState.error?.message}
          />
        )}
      />
    </>
  );
}
